import React from 'react'
// import Header from './components/Header/Header';
import Nav from './components/Nav/Nav';
import About from './components/About/About';
import Services from './components/Services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import Team from './components/Team/Team';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import NewHeader from './components/NewHeader/NewHeader';
// import ScrollToTop from './components/ScrollToTop';

const App = () => {
  return (
    <>
      <Nav />
      <NewHeader />
      <About />
      <Services />
      <Portfolio />
      <Team />
      <Contact />
      <Footer />
    </>
  )
}

export default App;
